<div class="card-1">
  <div class="row">
    <div class="col-md-6 col-12 mb-3">
      <label>Select Date</label>
      <kendo-dropdownlist [data]="sectorQuarterDates" [formControl]="dateSelector"></kendo-dropdownlist>
    </div>
  </div>
  <div>
    <div class="loader" *ngIf="loadingData"></div>
    <div *ngIf="gridData && gridData.length > 0 && !loadingData" class="responsive-table">
      <div *ngFor="let grid of gridData" class="sector-grid-container">
        <div class="table-name">
          <b>{{ grid.gridName }}</b>
        </div>
        <div class="hr-scrolable-table stripe-table">
          <table mat-table [dataSource]="grid.gridData.dataSource" class="table" multiTemplateDataRows>
            <ng-container *ngFor="let col of grid.gridColumns" [matColumnDef]="col.field">
              <th mat-header-cell *matHeaderCellDef class="nowrap-header">
                <span class="sector-hd">{{ col.label }}</span>
              </th>
              <td mat-cell *matCellDef="let element" [ngClass]="col.field === 'ticker' ? '' : 'text-end'">
                {{ element[col.field] }}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="grid.displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: grid.displayedColumns"></tr>
          </table>
          <!-- <mat-paginator
            [length]="grid.gridData.total"
            [pageIndex]="grid.gridData.pageIndex"
            [pageSize]="grid.gridData.pageSize"
            [pageSizeOptions]="[5, 10, 20]"
            (page)="grid.gridData.onPaginate($event)"
            showFirstLastButtons
          ></mat-paginator> -->
        </div>
      </div>
    </div>
  </div>
</div>
